.switcher {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--muted);
}

.select {
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  color: var(--ink);
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 0.25rem 0.5rem;
  max-width: 22rem;
}

/* Disabled must read as "not available", never as "broken" — the same
   treatment the Rule action uses for its 501. */
.select:disabled {
  color: var(--ink-soft);
  background: var(--paper-2);
  cursor: not-allowed;
}

.reason {
  margin: 0;
  max-width: 32rem;
  color: var(--muted);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

/* A refused switch is a real answer, not a broken control — but it must not be
   mistaken for the quiet "switching…" line above it. */
.error {
  margin: 0;
  max-width: 32rem;
  color: var(--stop);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}
